import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./ConfirmationPop.module.scss";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { getPdfBlob, successMessageToast, userFullName } from "helpers/common";
import { useEvaluatePeerMutation } from "store/services/clients/apprentice";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useUploadFileMutation } from "store/services/utility";
import { EvaluationReportPdfDoc } from "components/PDF/ChatterPeer/EvaluationReportPdf";

const EvaluationPop = ({ confirmation, setConfirmation, client, programId, refetch , tabDate='' }) => {

  const [isSubmitting, setSubmitting] = useState(false);
  const [initialValues, setInitialValues] = useState({
    showing_enthusiasm_and_attention: "1",
    keeping_participants_engaged: "1",
    "modelling_skills_using_strategies": "1",
    suggestion: "",
    email: client?.programMember?.email || "",
    name: userFullName(client?.programMember || {}) || ""
  });

  const [submitEvaluation, { isLoading }] = useEvaluatePeerMutation();

  const [uploadFile] = useUploadFileMutation();

  const handlePopup = () => {
    setConfirmation(false);
  };

  const evalutionCheck= client?.programMember.evaluatedPeer.some(x => x.session_date === tabDate) ? true : false; 

  const ratingValues = {
    "1": "needs_work",
    "2": "average",
    "3": "good",
    "4": "excellent"
  };

  const ratingKeys = {
    "needs_work": "1",
    "average": "2",
    "good": "3",
    "excellent": "4"
  };

  useEffect(() => {
    if (client) {
      setInitialValues({
        showing_enthusiasm_and_attention: ratingKeys[client?.programMember?.evaluatedPeer?.find(x => x.session_date == tabDate && x.evaluation_type == "showing_enthusiasm_and_attention")?.evaluation_rating] || "1",
        keeping_participants_engaged: ratingKeys[client?.programMember?.evaluatedPeer?.find(x => x.session_date == tabDate && x.evaluation_type == "keeping_participants_engaged")?.evaluation_rating] || "1",
        "modelling_skills_using_strategies": ratingKeys[client?.programMember?.evaluatedPeer?.find(x => x.session_date == tabDate && x.evaluation_type == "modelling_skills_using_strategies")?.evaluation_rating] || "1",
        // suggestion: "",
        suggestion: client?.programMember?.evaluatedPeer?.find(x => x.session_date == tabDate)?.suggestions || "",
        email: client?.programMember?.email || "",
        name: userFullName(client?.programMember || {}) || ""
      })
    };
  }, [client]);

  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);
      const payload = {
        session_date: tabDate || '',
        suggestions: values?.suggestion,
        ratings: [
          {
            evaluation_type: "showing_enthusiasm_and_attention",
            evaluation_rating: ratingValues[values?.["showing_enthusiasm_and_attention"]]
          },
          {
            evaluation_type: "keeping_participants_engaged",
            evaluation_rating: ratingValues[values?.["keeping_participants_engaged"]]
          },
          {
            evaluation_type: "modelling_skills_using_strategies",
            evaluation_rating: ratingValues[values?.["modelling_skills_using_strategies"]]
          }
        ]

      };

      const userData = {
        email: client?.programMember?.email || "",
        name: userFullName(client?.programMember || {}) || ""
      }

      const doc = (
        <EvaluationReportPdfDoc
          data={payload}
          userData={userData}
        />
      )
      let pdfFile = await getPdfBlob(doc, false, "volunteer_evaluation_form.pdf");

      let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private" }).unwrap();

      if (!uploadedFileName) {
        throw new Error("File not uploaded");
      };

      payload.evalution_document = uploadedFileName;

      const result = await submitEvaluation({ programId, peerId: client?.member_id, data: payload });
      if (result?.error) return;

      typeof refetch == "function" && refetch();
      handlePopup();
      successMessageToast(result?.data?.message);
    } catch (error) {
      console.log("Error evaluating peer", error)
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        show={confirmation}
        className={`${styles.AssignChecklist}  AssignChecklist`}
        onHide={handlePopup}
        backdrop="static"
        keyboard={false}
        centered
        scrollable="true"
        size="md"
      >
        <Modal.Body className={`${styles.modalBody} position-relative rounded px-4`}>
          <Button
            onClick={handlePopup}
            className="border-0 p-0 position-absolute"
            variant="transparent"
            style={{ right: 10, top: 0 }}
          >
            <CloseIcon />
          </Button>
          <div className="my-2">
            <h4 className="m-0 fw-bold themeBlue">Evaluation</h4>
            <h5 className="m-0 themeBlue">Date: {tabDate}</h5>
          </div>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            {({
              values,
              handleChange,
              handleSubmit
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md="12" sm="12" className="my-2">
                    <div>
                      <h5 className="m-0 fw-bold themeBlue">Showing enthusiasm and attention</h5>
                    </div>
                    <div className="my-2 w-100 d-flex justify-content-between">
                      <div className="d-flex flex-column align-items-center">
                        <NeedWorkIcon />
                        <span className="my-1 fw-bold" style={{ color: "#E24B4B", size: "14px" }}>
                          Needs Work
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <AverageIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Average
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <GoodIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Good
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <ExcellentIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Excellent
                        </span>
                      </div>

                    </div>
                    <div className="w-100">
                      <input
                        name="showing_enthusiasm_and_attention"
                        type="range"
                        className={`w-100 ${values?.showing_enthusiasm_and_attention == 1 ? "evaluation-range-bad" : values?.showing_enthusiasm_and_attention == 2 ? "evaluation-range-avarage" : values?.showing_enthusiasm_and_attention == 3 ? "evaluation-range-good" : values?.showing_enthusiasm_and_attention == 4 ? "evaluation-range-excellent" : ""}`}
                        min={"1"}
                        max={"4"}
                        step={"1"}
                        value={values?.showing_enthusiasm_and_attention}
                        onChange={handleChange}
                        // disabled={client?.programMember?.evaluatedPeer?.length || isLoading}
                        disabled={evalutionCheck || isLoading}
                      />
                    </div>
                  </Col>
                  <Col md="12" sm="12" className="my-2">
                    <div>
                      <h5 className="m-0 fw-bold themeBlue">Keeping participants engaged</h5>
                    </div>
                    <div className="my-2 w-100 d-flex justify-content-between">
                      <div className="d-flex flex-column align-items-center">
                        <NeedWorkIcon />
                        <span className="my-1 fw-bold" style={{ color: "#E24B4B", size: "14px" }}>
                          Needs Work
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <AverageIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Average
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <GoodIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Good
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <ExcellentIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Excellent
                        </span>
                      </div>

                    </div>
                    <div className="w-100">
                      <input
                        name="keeping_participants_engaged"
                        type="range"
                        className={`w-100 ${values?.keeping_participants_engaged == 1 ? "evaluation-range-bad" : values?.keeping_participants_engaged == 2 ? "evaluation-range-avarage" : values?.keeping_participants_engaged == 3 ? "evaluation-range-good" : values?.keeping_participants_engaged == 4 ? "evaluation-range-excellent" : ""}`}
                        min={"1"}
                        max={"4"}
                        step={"1"}
                        value={values?.keeping_participants_engaged}
                        onChange={handleChange}
                        // disabled={client?.programMember?.evaluatedPeer?.length || isLoading}
                        disabled={evalutionCheck || isLoading}
                      />
                    </div>
                  </Col>
                  <Col md="12" sm="12" className="my-2">
                    <div>
                      <h5 className="m-0 fw-bold themeBlue">Modelling skills & using strategies</h5>
                    </div>
                    <div className="my-2 w-100 d-flex justify-content-between">
                      <div className="d-flex flex-column align-items-center">
                        <NeedWorkIcon />
                        <span className="my-1 fw-bold" style={{ color: "#E24B4B", size: "14px" }}>
                          Needs Work
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <AverageIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Average
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <GoodIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Good
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <ExcellentIcon />
                        <span className="my-1 fw-bold" style={{ color: "#9C9C9C", size: "14px" }}>
                          Excellent
                        </span>
                      </div>

                    </div>
                    <div className="w-100">
                      <input
                        name="modelling_skills_using_strategies"
                        type="range"
                        className={`w-100 ${values?.["modelling_skills_using_strategies"] == 1 ? "evaluation-range-bad" : values?.["modelling_skills_using_strategies"] == 2 ? "evaluation-range-avarage" : values?.["modelling_skills_using_strategies"] == 3 ? "evaluation-range-good" : values?.["modelling_skills_using_strategies"] == 4 ? "evaluation-range-excellent" : ""}`}
                        min={"1"}
                        max={"4"}
                        step={"1"}
                        value={values?.["modelling_skills_using_strategies"]}
                        onChange={handleChange}
                        // disabled={client?.programMember?.evaluatedPeer?.length || isLoading}
                        disabled={evalutionCheck || isLoading}
                      />
                    </div>
                  </Col>
                  <Col md="12" sm="12" className="my-2">
                    <AppInputField
                      name="suggestion"
                      fieldType={"textarea"}
                      maxLength="500"
                      className={"form-control"}
                      style={{ height: "80px" }}
                      placeholder="Suggestions"
                      // disabled={client?.programMember?.evaluatedPeer?.length || isLoading}
                      disabled={evalutionCheck || isLoading}
                    />
                  </Col>
                  <Col md="12" sm="12" className="my-2">
                    <div>
                      <h5 className="m-0 fw-bold themeBlue">Enter Name</h5>
                    </div>
                    <AppInputField
                      name="name"
                      maxLength="500"
                      className={"form-control mt-2"}
                      placeholder="Enter Name"
                      disabled
                    />
                  </Col>
                  <Col md="12" sm="12" className="my-2">
                    <div>
                      <h5 className="m-0 fw-bold themeBlue">Enter Email</h5>
                    </div>
                    <AppInputField
                      name="email"
                      maxLength="500"
                      className={"form-control mt-2"}
                      placeholder="Enter Name"
                      disabled
                    />
                  </Col>
                  <Col md="12" sm="12" className="my-2">
                    <div className="w-100 d-flex flex-column align-items-center justify-content-center">
                      <Button
                        type="submit"
                        className="w-100 btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                        // disabled={client?.programMember?.evaluatedPeer?.length || isLoading}
                        disabled={evalutionCheck || isSubmitting}
                      >
                        {/* {client?.programMember?.evaluatedPeer?.length ? "Already Submitted" : isLoading ? <LoadingIndicator color="#FFF" /> : "Save"} */}
                        {evalutionCheck ? "Already Submitted" : isSubmitting ? <LoadingIndicator color="#FFF" /> : "Save"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal >
    </>
  );
};

export default EvaluationPop;


const NeedWorkIcon = () => {
  return (
    <svg width="35" height="35" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7351_11921)">
        <path d="M40.4702 20.1631C40.4702 31.2131 31.5077 40.1631 20.4702 40.1631C9.42021 40.1631 0.470215 31.2131 0.470215 20.1631C0.470215 9.12559 9.42021 0.163086 20.4702 0.163086C31.5077 0.163086 40.4702 9.12559 40.4702 20.1631Z" fill="#E24B4B" />
        <path d="M40.4703 20.1629C40.4703 31.2129 31.5078 40.1629 20.4703 40.1629C14.1703 40.1629 8.54526 37.2504 4.89526 32.7004C8.32026 35.4504 12.6578 37.0879 17.3953 37.0879C28.4328 37.0879 37.3953 28.1379 37.3953 17.0879C37.3953 12.3504 35.7578 8.01289 32.9953 4.58789C37.5578 8.25039 40.4703 13.8629 40.4703 20.1629Z" fill="#D03F3F" />
        <path d="M16.3662 16.2215C16.2413 16.2216 16.1182 16.1916 16.0073 16.1342C15.8964 16.0767 15.8008 15.9935 15.7287 15.8915C14.345 13.939 12.4562 12.694 9.7825 11.9765C9.36625 11.864 9.11875 11.4353 9.23125 11.019C9.34375 10.6015 9.77 10.3578 10.1887 10.4678C12.7725 11.1628 14.785 12.354 16.305 14.099L17.4012 12.404C17.6337 12.0415 18.12 11.9378 18.48 12.1715C18.8425 12.4065 18.9462 12.889 18.7125 13.2515L17.0225 15.864C16.9532 15.9712 16.8588 16.0598 16.7475 16.1221C16.6362 16.1844 16.5113 16.2185 16.3837 16.2215H16.3662Z" fill="#3E4347" />
        <path d="M13.1429 23.3265C14.8867 23.3265 16.3004 21.7192 16.3004 19.7365C16.3004 17.7538 14.8867 16.1465 13.1429 16.1465C11.399 16.1465 9.98535 17.7538 9.98535 19.7365C9.98535 21.7192 11.399 23.3265 13.1429 23.3265Z" fill="#3E4347" />
        <path d="M24.5739 16.2218H24.5564C24.2977 16.2168 24.0589 16.0818 23.9164 15.8643L22.2277 13.2518C21.9939 12.8893 22.0977 12.4056 22.4602 12.1718C22.8214 11.9368 23.3064 12.0418 23.5402 12.4043L24.6339 14.0981C26.1552 12.3543 28.1664 11.1618 30.7514 10.4681C31.1702 10.3543 31.5964 10.6018 31.7089 11.0193C31.8214 11.4356 31.5739 11.8643 31.1577 11.9768C28.4839 12.6956 26.5952 13.9393 25.2102 15.8931C25.0652 16.0993 24.8264 16.2218 24.5739 16.2218Z" fill="#3E4347" />
        <path d="M27.7976 23.3265C29.5415 23.3265 30.9551 21.7192 30.9551 19.7365C30.9551 17.7538 29.5415 16.1465 27.7976 16.1465C26.0538 16.1465 24.6401 17.7538 24.6401 19.7365C24.6401 21.7192 26.0538 23.3265 27.7976 23.3265Z" fill="#3E4347" />
        <path d="M26.2216 31.5243C24.7478 29.9831 22.6403 29.1006 20.4366 29.1006C18.2328 29.1006 16.1253 29.9843 14.6516 31.5243C14.1728 32.0243 13.3803 32.0393 12.8841 31.5631C12.3853 31.0856 12.3678 30.2943 12.8453 29.7956C14.7891 27.7643 17.5553 26.6006 20.4366 26.6006C23.3191 26.6006 26.0853 27.7656 28.0278 29.7956C28.5053 30.2943 28.4878 31.0856 27.9891 31.5631C27.4928 32.0393 26.7003 32.0243 26.2216 31.5243Z" fill="#3E4347" />
        <path d="M29.5541 19.2435C29.2841 19.3522 28.9403 19.126 28.7778 18.736C28.6253 18.3447 28.7116 17.9422 28.9816 17.8335C29.2616 17.7235 29.6066 17.9497 29.7578 18.341C29.9203 18.7297 29.8241 19.1347 29.5541 19.2435ZM14.7691 19.2435C14.4991 19.3522 14.1553 19.126 13.9928 18.736C13.8416 18.3447 13.9266 17.9422 14.1978 17.8335C14.4778 17.7235 14.8228 17.9497 14.9741 18.341C15.1353 18.7297 15.0391 19.1347 14.7691 19.2435Z" fill="#5A5F63" />
      </g>
      <defs>
        <clipPath id="clip0_7351_11921">
          <rect width="40" height="40" fill="white" transform="translate(0.470215 0.163086)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const AverageIcon = () => {

  return (
    <svg width="35" height="35" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7351_11934)">
        <path d="M20.3037 40.9717C31.3494 40.9717 40.3037 32.0174 40.3037 20.9717C40.3037 9.92598 31.3494 0.97168 20.3037 0.97168C9.25802 0.97168 0.303711 9.92598 0.303711 20.9717C0.303711 32.0174 9.25802 40.9717 20.3037 40.9717Z" fill="#FFD93B" />
        <path d="M40.3036 20.9721C40.3036 32.0221 31.3474 40.9721 20.3036 40.9721C14.0161 40.9721 8.40361 38.0721 4.73486 33.5283C8.16611 36.3033 12.5349 37.9596 17.2911 37.9596C28.3349 37.9596 37.2911 29.0096 37.2911 17.9596C37.2911 13.2033 35.6349 8.83457 32.8599 5.40332C37.3974 9.07207 40.3036 14.6846 40.3036 20.9721Z" fill="#F4C534" />
        <path d="M27.6612 21.7355C29.3947 21.7355 30.8 20.3302 30.8 18.5968C30.8 16.8633 29.3947 15.458 27.6612 15.458C25.9277 15.458 24.5225 16.8633 24.5225 18.5968C24.5225 20.3302 25.9277 21.7355 27.6612 21.7355Z" fill="#3E4347" />
        <path d="M28.8016 16.6438C28.322 16.4311 27.8216 16.5104 27.6839 16.8208C27.5462 17.1313 27.8233 17.5555 28.303 17.7682C28.7826 17.9809 29.283 17.9016 29.4207 17.5911C29.5584 17.2806 29.2812 16.8565 28.8016 16.6438Z" fill="#5A5F63" />
        <path d="M12.9461 21.7355C14.6796 21.7355 16.0849 20.3302 16.0849 18.5968C16.0849 16.8633 14.6796 15.458 12.9461 15.458C11.2126 15.458 9.80737 16.8633 9.80737 18.5968C9.80737 20.3302 11.2126 21.7355 12.9461 21.7355Z" fill="#3E4347" />
        <path d="M14.0853 16.6438C13.6057 16.4311 13.1053 16.5104 12.9676 16.8208C12.8299 17.1313 13.107 17.5555 13.5867 17.7682C14.0663 17.9809 14.5667 17.9016 14.7044 17.5911C14.8421 17.2806 14.5649 16.8565 14.0853 16.6438Z" fill="#5A5F63" />
        <path d="M14.383 28.8667C14.1101 28.5117 14.0975 27.918 14.354 27.5417C14.6106 27.1655 15.0388 27.1467 15.3116 27.5017C18.1112 31.148 22.4963 31.148 25.2959 27.5017C25.5687 27.1467 25.9969 27.1655 26.2535 27.5417C26.5101 27.9192 26.4974 28.5117 26.2246 28.8667C22.9046 33.1917 17.7029 33.1917 14.383 28.8667Z" fill="#3E4347" />
      </g>
      <defs>
        <clipPath id="clip0_7351_11934">
          <rect width="40" height="40" fill="white" transform="translate(0.303711 0.97168)" />
        </clipPath>
      </defs>
    </svg>

  );
};

const GoodIcon = () => {
  return (
    <svg width="35" height="35" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7351_11945)">
        <path d="M20.4702 40.9717C31.5159 40.9717 40.4702 32.0174 40.4702 20.9717C40.4702 9.92598 31.5159 0.97168 20.4702 0.97168C9.42452 0.97168 0.470215 9.92598 0.470215 20.9717C0.470215 32.0174 9.42452 40.9717 20.4702 40.9717Z" fill="#AEE658" />
        <path d="M20.4703 33.8262C14.6216 33.8262 9.52535 29.865 8.07785 24.195C7.9641 23.7487 8.23285 23.295 8.6791 23.1812C9.12285 23.065 9.57785 23.3362 9.6916 23.7825C10.9516 28.715 15.3828 32.16 20.4691 32.16C25.5553 32.16 29.9878 28.715 31.2466 23.7825C31.3591 23.3362 31.8128 23.065 32.2603 23.1812C32.7066 23.295 32.9753 23.7487 32.8616 24.195C31.4153 29.865 26.3191 33.8262 20.4703 33.8262Z" fill="#3E4347" />
        <path d="M40.4701 20.9721C40.4701 32.0221 31.5139 40.9721 20.4701 40.9721C14.1826 40.9721 8.57012 38.0721 4.90137 33.5283C8.33262 36.3033 12.7014 37.9596 17.4576 37.9596C28.5014 37.9596 37.4576 29.0096 37.4576 17.9596C37.4576 13.2033 35.8014 8.83457 33.0264 5.40332C37.5639 9.07207 40.4701 14.6846 40.4701 20.9721Z" fill="#9CD454" />
        <path d="M14.0113 21.825C15.704 21.825 17.0763 20.1942 17.0763 18.1825C17.0763 16.1708 15.704 14.54 14.0113 14.54C12.3185 14.54 10.9463 16.1708 10.9463 18.1825C10.9463 20.1942 12.3185 21.825 14.0113 21.825Z" fill="#3E4347" />
        <path d="M15.394 17.3991C15.1552 17.5866 14.7627 17.4941 14.5115 17.1891C14.2602 16.8841 14.2477 16.4753 14.4865 16.2878C14.724 16.0916 15.1177 16.1841 15.3677 16.4891C15.6202 16.8028 15.6227 17.2041 15.394 17.3991Z" fill="#5A5F63" />
        <path d="M26.9327 21.825C28.6254 21.825 29.9977 20.1942 29.9977 18.1825C29.9977 16.1708 28.6254 14.54 26.9327 14.54C25.2399 14.54 23.8677 16.1708 23.8677 18.1825C23.8677 20.1942 25.2399 21.825 26.9327 21.825Z" fill="#3E4347" />
        <path d="M28.3127 17.3991C28.0739 17.5866 27.6814 17.4941 27.4302 17.1891C27.1789 16.8841 27.1664 16.4753 27.4052 16.2878C27.6427 16.0916 28.0352 16.1841 28.2864 16.4891C28.5389 16.8028 28.5414 17.2041 28.3127 17.3991Z" fill="#5A5F63" />
      </g>
      <defs>
        <clipPath id="clip0_7351_11945">
          <rect width="40" height="40" fill="white" transform="translate(0.470215 0.97168)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ExcellentIcon = () => {
  return (
    <svg width="35" height="35" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7351_11956)">
        <path d="M20.9702 40.9717C32.0159 40.9717 40.9702 32.0174 40.9702 20.9717C40.9702 9.92598 32.0159 0.97168 20.9702 0.97168C9.92452 0.97168 0.970215 9.92598 0.970215 20.9717C0.970215 32.0174 9.92452 40.9717 20.9702 40.9717Z" fill="url(#paint0_linear_7351_11956)" />
        <path d="M20.9702 19.7998C17.7384 19.7998 15.1108 22.9538 15.1108 26.8311C15.1108 30.7083 17.7384 33.8623 20.9702 33.8623C24.202 33.8623 26.8296 30.7083 26.8296 26.8311C26.8296 22.9538 24.202 19.7998 20.9702 19.7998ZM17.4546 16.2842V13.9404C17.4546 13.2927 16.9304 12.7686 16.2827 12.7686H9.25146C8.60373 12.7686 8.07959 13.2927 8.07959 13.9404C8.07959 14.5882 8.60373 15.1123 9.25146 15.1123H10.4233V16.2842C10.4233 18.2228 12.0004 19.7998 13.939 19.7998C15.8776 19.7998 17.4546 18.2228 17.4546 16.2842ZM30.3452 12.7686H23.314C22.6662 12.7686 22.1421 13.2927 22.1421 13.9404C22.1421 14.5882 22.6662 15.1123 23.314 15.1123H24.4858V16.2842C24.4858 18.2228 26.0629 19.7998 28.0015 19.7998C29.9401 19.7998 31.5171 18.2228 31.5171 16.2842V13.9404C31.5171 13.2927 30.9929 12.7686 30.3452 12.7686Z" fill="url(#paint1_linear_7351_11956)" />
      </g>
      <defs>
        <linearGradient id="paint0_linear_7351_11956" x1="20.9702" y1="40.9717" x2="20.9702" y2="0.97168" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00B59C" />
          <stop offset="1" stopColor="#9CFFAC" />
        </linearGradient>
        <linearGradient id="paint1_linear_7351_11956" x1="19.7983" y1="33.8623" x2="19.7983" y2="12.7686" gradientUnits="userSpaceOnUse">
          <stop stopColor="#C3FFE8" />
          <stop offset="0.997" stop-color="#F0FFF4" />
        </linearGradient>
        <clipPath id="clip0_7351_11956">
          <rect width="40" height="40" fill="white" transform="translate(0.970215 0.97168)" />
        </clipPath>
      </defs>
    </svg>
  );
};